import {
  Box, MenuItem, Select, Table, TableBody, TableCell,
  TableHead, TableRow, TextField, Typography, Accordion, AccordionSummary, AccordionDetails
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import { COMMON_STYLE, NEW_DOC_DURATION_LIST_OTHER } from '../../../../Utility/Constants'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker, DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers'
import DeleteIcon from '@mui/icons-material/Delete';
import ShowComponents from '../../DoctorNotes/Common/ShowComponent'
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation'
import { DateTime } from 'luxon'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import dayjs from "dayjs";


const UmaReviewPlan = React.forwardRef((props, ref) => {
  const [review, setReview] = useState({
  durationList: NEW_DOC_DURATION_LIST_OTHER,
  openDate: false,
  duration_type: "Days",
  duration: '',
  review_date: new Date(),
  appointment_time: "",
  comments: "",
  dupDuration: '',
  dupDuration_type: '',
  dupReview_date: new Date(),
  dupComments: '',
  changeDur: false
})
  const [message, setMessage] = useState({
    isErrorMsgText: '',
    successMsgText: '',
    isErrorMsg: false,
    successMsg: false,
  })

  React.useImperativeHandle(ref, () => ({
    performReviewPlanAction: () => {
      let reviewDate = new Date(JSON.parse(review.dupReview_date))
      if (
        (JSON.stringify(review.duration) !== review.dupDuration) || (review.dupDuration_type !== JSON.stringify(review.duration_type)) ||
        (reviewDate !== review.review_date) || (review.dupComments !== JSON.stringify(review.comments))
      ) {
        postReviewPlanData()
      }
    }
  }))

  const errorMessage = (message) => {
    setMessage({
      ...message,
      isErrorMsg: true,
      isErrorMsgText: `${message} - REVIEW PLAN`,
    })
  }

  const successMessage = (message) => {
    setMessage({
      ...message,
      successMsg: true,
      successMsgText: `${message} - REVIEW PLAN`,
    })
  }

  const msgClose = () => {
    setMessage({
      ...message,
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  useEffect(() => {
    if (review.changeDur) {
      let date = new Date(review.review_date)
      let reviewDate = DateTime.fromJSDate(date).plus({ [review.duration_type?.toLowerCase()]: +review.duration })
      setReview((prev) => ({
        ...prev,
        review_date: reviewDate?.toFormat('yyyy-MM-dd HH:mm:ss'),
        changeDur: false
      }))
    }
  }, [review.changeDur])

  const apicalls = async () => {
    await getReviewPlanData()
  }

  const getReviewPlanData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_REVIEW_PLAN + '?appointment_id=' + props?.props?.appointment_id + '&doctor_id=' + props?.props?.doctorID)
      if (response?.data?.status === 'success') {
        setReview((prev) => ({
          ...prev,
          duration_type: response?.data?.data?.duration_type ? response?.data?.data?.duration_type : 'Days',
          duration: response?.data?.data?.duration ? response?.data?.data?.duration : '',
          review_date: response?.data?.data?.review_date ? new Date(`${response?.data?.data?.review_date} ${response?.data?.data?.appointment_time}`) : new Date(),
          comments: response?.data?.data?.comments ? response?.data?.data?.comments : '',
          dupDuration_type: response?.data?.data?.duration_type ? JSON.stringify(response?.data?.data?.duration_type) : JSON.stringify('Days'),
          dupDuration: response?.data?.data?.duration ? JSON.stringify(response?.data?.data?.duration) : JSON.stringify(''),
          dupReview_date: response?.data?.data?.review_date ? JSON.stringify(new Date(`${response?.data?.data?.review_date} ${response?.data?.data?.appointment_time}`)) : JSON.stringify(new Date()),
          dupComments: response?.data?.data?.comments ? JSON.stringify(response?.data?.data?.comments) : JSON.stringify(''),
        }))
        props.setAccordionOpen((response?.data?.data?.duration_type || response?.data?.data?.duration
          || response?.data?.data?.review_date || (response?.data?.data?.comments && response?.data?.data?.comments?.trim())) ? true : false);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const postReviewPlanData = async () => {
    try {
      var AptDateTime = new Date(review.review_date)
      var AptDate = DateTime.fromJSDate(AptDateTime).toFormat('yyyy-MM-dd')
      var Aptime = DateTime.fromJSDate(AptDateTime).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
      let data = {
        appointment_id: props?.props?.appointment_id,
        duration_type: review.duration_type,
        duration: +review.duration,
        review_date: AptDate,
        appointment_time: Aptime,
        comments: review.comments
      }
      const response = await RestAPIService.create(data, Serviceurls.NEW_DOC_NOTES_REVIEW_PLAN)
      if (response?.data?.status === 'success') {
        successMessage(response?.data?.message)
        await getReviewPlanData()
      }

    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const onChangeHandler = (newValue, key) => {
    try {
      setReview((prev) => {
        switch (key) {
          case 'duration':
            if (CommonValidation.numberOnly(newValue) && newValue <= 20 || newValue === '') {
              return { ...prev, duration: newValue, review_date: new Date(), changeDur: true }
            } else {
              return { ...prev, review_date: new Date(), changeDur: true }
            }
          case 'duration_type':
            return { ...prev, duration_type: newValue, review_date: new Date(), changeDur: true }
          case 'comments':
            return { ...prev, comments: newValue }
        }
      })
    } catch (error) {
      errorMessage(error.message)
    }
  }

  return (
    <ShowComponents onIntersection={apicalls}>
      <Box component={'div'}>
        <Accordion expanded={props.accordionOpen}
          onChange={(_, isExpanded) => {
            props.setAccordionOpen(isExpanded, true);
          }}>
          <AccordionSummary className='doc_notes_header_card' expandIcon={<ExpandMoreIcon />}>
            <Typography className='doc_notes_header_card_font'>Review Plan</Typography>
          </AccordionSummary>
          <AccordionDetails component={'div'} m={'0.5rem'}>
            <Box component={'div'} border={'1px solid lightgray'}>
              <Table size='small'>
                <TableHead>
                  <TableRow>
                    <TableCell className='doc_notes_tbl_header'>Duration</TableCell>
                    <TableCell className='doc_notes_tbl_header'>Date & Time</TableCell>
                    <TableCell className='doc_notes_tbl_header'>Comments</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell className='doc_notes_tbl_body_cell'>
                      <Box component={'div'} display={'flex'} alignItems={'center'}>
                        <TextField
                          disabled={props?.props?.patient_transfered || props?.props?.isLocked}
                          autoComplete='off'
                          size='small'
                          sx={{ width: '4dvw' }}
                          InputProps={{
                            emed_tid: 'dur_rev',
                            style: { height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }
                          }}
                          value={review.duration}
                          onChange={(e) => {
                            let value = e.target.value
                            onChangeHandler(value, 'duration')
                          }} />
                        <Select
                          size="small"
                          sx={{ width: '5.5dvw', height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }}
                          value={review?.duration_type || ''}
                          onChange={(e) => onChangeHandler(e.target.value, 'duration_type')}
                          inputProps={{ emed_tid: 'rev_dur_type' }}
                          displayEmpty
                          disabled={props?.props?.patient_transfered || props?.props?.isLocked}
                        >
                          <MenuItem value="" disabled>Select Duration</MenuItem>
                          {review.durationList.map((option, idx) => (
                            <MenuItem key={idx} value={option?.value}>{option?.label}</MenuItem>
                          ))}
                        </Select>
                      </Box>
                    </TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateTimePicker
                          disabled={props?.props?.patient_transfered || props?.props?.isLocked}
                          open={review.openDate}
                          onOpen={() => setReview((prev) => ({ ...prev, openDate: true }))}
                          onClose={() => setReview((prev) => ({ ...prev, openDate: false }))}
                          value={review.review_date}
                          inputFormat='DD-MM-YYYY & hh:mm A'
                          minDate={new Date()}
                          onChange={(newDate) => {
                            setReview((prev) => {
                              const prevDate = dayjs(prev.review_date);
                              const nextDate = dayjs(newDate);

                              const shouldResetDuration = !prevDate.isSame(nextDate, "day");
                              return {
                                ...prev,
                                review_date: newDate,
                                duration: shouldResetDuration ? "" : prev.duration,
                              };
                            });
                          }}
                          renderInput={(params) => <TextField sx={{ width: '14dvw' }}
                            {...params}
                            InputProps={{ ...params.InputProps, style: { height: COMMON_STYLE.HEIGHT }, emed_tid: 'date' }}
                            onClick={() => setReview((prev) => ({ ...prev, openDate: true }))}
                          />}
                        />
                      </LocalizationProvider>
                    </TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>
                      <Box component={'div'}>
                        <TextField
                          disabled={props?.props?.patient_transfered || props?.props?.isLocked}
                          autoComplete='off'
                          multiline
                          maxRows={5}
                          size='small'
                          sx={{ width: '11dvw' }}
                          InputProps={{
                            emed_tid: 'rev_cmts',
                            style: review?.comments ? { maxHeight: COMMON_STYLE.MAX_HEIGHT } : { height: COMMON_STYLE.HEIGHT }
                          }}
                          value={review.comments}
                          onChange={(e) => {
                            let value = e.target.value
                            if (value?.length <= COMMON_STYLE.CHAR_LIMIT_COMMENTS || value === '') {
                              setReview((prev) => ({ ...prev, comments: value }))
                            }
                          }} />
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          </AccordionDetails>
        </Accordion>
        {message.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={message.isErrorMsgText}
            msgPop={msgClose}
          />
          : null}
        {message.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={message.successMsgText}
            msgPop={msgClose}
          />
          : null}
      </Box>
    </ShowComponents>
  )
})

export default UmaReviewPlan